import { NavLink, Outlet } from "react-router-dom";

const tabs = [
  {
    label: "Job Matches",
    route: "job-matches",
  },
  {
    label: "Job Matches 1",
    route: "job-matches1",
  },
  {
    label: "Job Matches 2",
    route: "job-matches2",
  },
  {
    label: "Job Track",
    route: "job-track",
  },
];


const JobPageLayout = () => {
  return (
    <div className="flex flex-col flex-1 rounded-md bg-white p-6">
      {/* Tabs container */}
      <div className="flex items-center border-b w-full pb-2 gap-10">
        {tabs?.map((tab) => {
          return (
            <NavLink
              key={tab?.label}
              to={`/job/${tab?.route}`}
              className={({ isActive }) =>
                `font-semibold text-xs ${isActive
                  ? "text-primary border-b border-primary"
                  : "text-light-grey"
                }  pb-0.5`
              }
            >
              {tab?.label}
            </NavLink>
          );
        })}
      </div>
      <Outlet />
    </div>
  );
};

export default JobPageLayout;
